/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlGetAllQuestions = "/onboarding/questions";
const urlCreateQuestion = "/onboarding/create-question";
const urlUpdateQuestion = "/onboarding/update-question";
const urlDeleteQuestion = "/onboarding/delete-question";
const urlChangeOrderQuestion = "/onboarding/change-order-question";
const urlSaveConfig = "/onboarding/save-configs";
const urlSaveQuestionsAndConfigs = "/onboarding/save-questions-and-configs";

const state = {
  questions: [],
  configs: {},
};

const actions = {
  /**
   * Get all questions
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getAllQuestions({ commit }, query) {
    try {
      const response = await axios.get(
        urlGetAllQuestions + "?" + new URLSearchParams(query),
      );
      if (response.data.status_code === 200) {
        commit("SET_DATA_ONBOARDING", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create question
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async createQuestion({ commit }, payload) {
    return await axios.post(urlCreateQuestion, payload);
  },

  /**
   * Update question
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async updateQuestion({ commit }, payload) {
    return await axios.post(urlUpdateQuestion, payload);
  },

  /**
   * Delete question
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async deleteQuestion({ commit }, payload) {
    return await axios.post(urlDeleteQuestion, payload);
  },

  /**
   * Change order questions
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async changeOrderQuestions({ commit }, payload) {
    return await axios.post(urlChangeOrderQuestion, payload);
  },

  /**
   * Save config
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async saveConfigs({ commit }, payload) {
    return await axios.post(urlSaveConfig, payload);
  },

  /**
   * Save questions and configs
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async saveQuestionsAndConfigs({ commit }, payload) {
    return await axios.post(urlSaveQuestionsAndConfigs, payload);
  },
};

const mutations = {
  SET_DATA_ONBOARDING(state, data) {
    state.questions = data.questions;
    state.configs = data.configs;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
